import { buildSalaryMultiplierTypedAmount } from "./salaryMultiplierTypedAmount";
import { definitionOfEarningsSpec, rateGuarantee } from "./sharedTypedAmount";
import { SENTINEL_LABELS } from "./shared";

import type {
  TypedAmountSpec,
  TypedAmountTypeOption,
} from "../typedAmountTypes";

const SALARY_MULTIPLIER_LABEL = "Salary Multiplier";

const DOLLAR_AMOUNT: TypedAmountTypeOption = {
  value: "dollarAmount",
  label: "Dollar amount",
};

const NOT_INCLUDED: TypedAmountTypeOption = {
  value: "notIncluded",
  label: SENTINEL_LABELS["notIncluded"],
  hideAmount: true,
};
const NOT_DISCLOSED: TypedAmountTypeOption = {
  value: "notDisclosed",
  label: SENTINEL_LABELS["notDisclosed"],
  hideAmount: true,
};
const NOT_APPLICABLE: TypedAmountTypeOption = {
  value: "notApplicable",
  label: SENTINEL_LABELS["notApplicable"],
  hideAmount: true,
};
const NOT_OFFERED: TypedAmountTypeOption = {
  value: "notOffered",
  label: SENTINEL_LABELS["notOffered"],
  hideAmount: true,
};
const DOLLAR_ONLY_OPTIONS: TypedAmountTypeOption[] = [
  DOLLAR_AMOUNT,
  NOT_INCLUDED,
  NOT_DISCLOSED,
];

const AMOUNT_NOT_TO_EXCEED_OPTIONS: TypedAmountTypeOption[] = [
  { value: "percentageOfEmployeeElection", label: "Percentage of EE Election" },
  NOT_APPLICABLE,
  NOT_INCLUDED,
  NOT_OFFERED,
  NOT_DISCLOSED,
];

// Benefit Maximum - Employee: a dollar amount, a salary multiplier, or the
// lesser of the two. The salary-multiplier input is gated to the two
// multiplier-bearing types; the dollar input hides for the pure multiplier.
const BENEFIT_MAXIMUM_EMPLOYEE_OPTIONS: TypedAmountTypeOption[] = [
  { value: "dollarAmount", label: "Dollar Amount" },
  {
    value: "salaryMultiplier",
    label: SALARY_MULTIPLIER_LABEL,
    hideAmount: true,
  },
  {
    value: "lesserOfDollarAmountOrSalaryMultiplier",
    label: "Lesser of Dollar Amount or Salary Multiplier",
  },
  NOT_DISCLOSED,
];

export const volLifeTypedAmountFields: Record<string, TypedAmountSpec> = {
  benefitMaximumEmployee: buildSalaryMultiplierTypedAmount({
    typeKey: "benefitMaximumEmployeeType",
    dollarKey: "benefitMaximumEmployeeDollarAmount",
    multiplierKey: "benefitMaximumEmployeeSalaryMultiplier",
    typeOptions: BENEFIT_MAXIMUM_EMPLOYEE_OPTIONS,
    multiplierTypes: [
      "salaryMultiplier",
      "lesserOfDollarAmountOrSalaryMultiplier",
    ],
  }),
  benefitMaximumSpouse: {
    typeKey: "benefitMaximumSpouseType",
    amountKey: "benefitMaximumSpouseAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_ONLY_OPTIONS,
  },
  amountNotToExceedSpouse: {
    typeKey: "amountNotToExceedSpouseType",
    amountKey: "amountNotToExceedSpouseAmount",
    amountLabel: "Percentage",
    typeOptions: AMOUNT_NOT_TO_EXCEED_OPTIONS,
  },
  benefitMaximumChild: {
    typeKey: "benefitMaximumChildType",
    amountKey: "benefitMaximumChildAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_ONLY_OPTIONS,
  },
  amountNotToExceedChild: {
    typeKey: "amountNotToExceedChildType",
    amountKey: "amountNotToExceedChildAmount",
    amountLabel: "Percentage",
    typeOptions: AMOUNT_NOT_TO_EXCEED_OPTIONS,
  },
  studentStatusStudentLimitingAge: {
    typeKey: "studentStatusStudentLimitingAgeType",
    amountKey: "studentStatusStudentLimitingAgeAmount",
    amountLabel: "Age",
    typeOptions: [
      { value: "included", label: "Included", hideAmount: true },
      NOT_INCLUDED,
      NOT_OFFERED,
    ],
  },
  definitionOfEarnings: definitionOfEarningsSpec,
  rateGuarantee,
};
